import * as angular from "angular";
import {IController} from "angular";

export class ExpensesViewSettingsPanelTemplateCtrl implements IController {

  settings: any;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: any;

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: false,
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey].enabled = isEnabled;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }

}

angular
  .module('bringoz.admin.expenses')
  .component('expensesViewSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./expenses-view-settings-panel-template.html').default,
    controller: ExpensesViewSettingsPanelTemplateCtrl
  });
